<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import {onMounted, onUnmounted} from "vue";

export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
